import React from 'react'
import ReactDOM from 'react-dom'
import { GoogleOAuthProvider } from '@react-oauth/google'
import './index.css'
import App from './App'

// Firebase init — same `nerdle` project as the maffdoku family, so analytics
// events and Firestore writes land in the existing pipeline (GA4 → BigQuery for
// events, Firestore → BigQuery for documents). Config copied verbatim from
// ../maffdoku/src/index.tsx.
import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
import { getFirestore } from 'firebase/firestore'

const firebaseConfig = {
  apiKey: 'AIzaSyCrw9zOEPd_8YN6hCutWzKqE4-ESV1cINY',
  authDomain: 'nerdle.firebaseapp.com',
  databaseURL: 'https://nerdle-default-rtdb.europe-west1.firebasedatabase.app',
  projectId: 'nerdle',
  storageBucket: 'nerdle.appspot.com',
  messagingSenderId: '31436486735',
  appId: '1:31436486735:web:20ebd7255a9cc8324c523a',
  measurementId: 'G-MRLY2WKXE9',
}

const app = initializeApp(firebaseConfig)
export const analytics = getAnalytics(app)
// Firestore handle for voice-session + consent writes (see src/shared/labs/sessionStore.ts).
export const db = getFirestore(app)

// nerdle's Google OAuth client (from the main game's index.tsx). Works on labs because
// labs is the same origin (nerdlegame.com). Used by the re-engagement panel sign-up.
const GOOGLE_CLIENT_ID = '31436486735-bhmnsmajv93uuausn61nckdstfhq36c7.apps.googleusercontent.com'

ReactDOM.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <App />
    </GoogleOAuthProvider>
  </React.StrictMode>,
  document.getElementById('root')
)
